import { SimpleList } from '@store/models/SimpleList';
import { EntryListItem, OfficeData } from 'chaika-frontend-types/frontend-cms';

export class RenderedServicesEntriesList extends SimpleList<EntryListItem & { office?: OfficeData }> {}
